import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { qk } from '../../lib/query'
import { useUi } from '../../state/UiContext'
import { Icon } from '../icons'
import { useToast } from '../ui/Toaster'

function money(n: number) {
  return `R$ ${n.toFixed(2).replace('.', ',')}`
}

const MAX = 50

const STOCK_LABEL: Record<string, [string, string]> = {
  in_stock: ['ok', 'Em estoque'],
  low: ['low', 'Últimas unidades'],
  backorder: ['no', 'Sob encomenda'],
}

export function ProductsTab({ conversationId }: { conversationId: string }) {
  const [q, setQ] = useState('')
  const { dispatch } = useUi()
  const toast = useToast()
  const { data: all } = useQuery({ queryKey: qk.products(q), queryFn: () => api.products(q) })
  // Sem busca a lista é o catálogo inteiro (milhares). Os primeiros bastam; a busca afunila.
  const products = all?.slice(0, MAX)
  const ids = (products ?? []).map((p) => p.id)
  /**
   * O anúncio que de fato iria para o cliente NESTA conversa — na Shopee, o da loja dela, pela
   * mesma consulta do envio. Serve para conferir antes de mandar.
   */
  const { data: links } = useQuery({
    queryKey: ['product-links', conversationId, ids.join(',')],
    queryFn: () => api.productLinks(conversationId, ids),
    enabled: ids.length > 0,
    staleTime: 60_000,
  })

  return (
    <>
      <div className="psearch">
        <Icon name="search" />
        <input placeholder="Buscar produto ou SKU…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      {!products || products.length === 0 ? (
        <div className="empty">Nenhum produto encontrado.</div>
      ) : (
        products.map((p) => {
          const stk = STOCK_LABEL[p.availability] ?? STOCK_LABEL.in_stock
          const link = links?.[p.id]
          return (
            <div className="prow" key={p.id}>
              {p.imageUrl ? (
                <img className="pthumb-img" src={p.imageUrl} alt="" loading="lazy" referrerPolicy="no-referrer" />
              ) : (
                <span className="pthumb">{p.imageEmoji ?? '📦'}</span>
              )}
              <div className="info">
                {link?.url ? (
                  <a className="nm nm-link" href={link.url} target="_blank" rel="noreferrer" title={`Abrir o anúncio que será enviado: ${link.url}`}>
                    {p.name}
                  </a>
                ) : (
                  <div className="nm">{p.name}</div>
                )}
                <div className="sku">
                  {p.sku} · {p.sizeLabel}
                </div>
                <div className="pr">
                  {money(p.price)}
                  {stk && (
                    <span className={`stk ${stk[0]}`}>{stk[1]}</span>
                  )}
                </div>
                {link?.note && <div className="pnote">{link.note}</div>}
              </div>
              <button
                className="btn sec sm"
                disabled={link ? !link.sendable : false}
                title={link && !link.sendable ? (link.note ?? undefined) : undefined}
                onClick={() => {
                  dispatch({ type: 'addAttachment', conversationId, productId: p.id })
                  dispatch({ type: 'setComposeMode', mode: 'reply' })
                  toast('Produto adicionado à mensagem')
                }}
              >
                Enviar
              </button>
            </div>
          )
        })
      )}
      {all && all.length > MAX && <div className="pnote" style={{ padding: '4px 2px' }}>Mostrando {MAX} de {all.length}. Busque pelo nome ou SKU.</div>}
    </>
  )
}
